/**
 * useInvoiceData Hook (BLU-328)
 *
 * Lazy tRPC query wrappers for fetching invoice data.
 * Queries are disabled by default and enabled on demand via the `enabled` flag.
 */

import { trpc } from '@/lib/trpc';

/**
 * Fetch invoice data for all orders in a batch.
 * Only fires when `enabled` is true (set on button click).
 */
export function useInvoiceBatchData(
  batchId: string | undefined,
  enabled: boolean = false
) {
  return trpc.productionOrders.getInvoiceBatchData.useQuery(
    { batchId: batchId! },
    { enabled: enabled && !!batchId, staleTime: 5 * 60 * 1000 }
  );
}

/**
 * Fetch invoice data for a single production order.
 * Only fires when `enabled` is true (set on button click).
 */
export function useInvoiceOrderData(
  orderId: string | undefined,
  enabled: boolean = false
) {
  return trpc.productionOrders.getInvoiceOrderData.useQuery(
    { orderId: orderId! },
    { enabled: enabled && !!orderId, staleTime: 5 * 60 * 1000 }
  );
}
